import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '@/api';

export const fetchCompanyList = createAsyncThunk('/company', async () => {
  return (await api.get('/company')).data;
});

export const fetchCompanySolutionList = createAsyncThunk('/solution/company', async (payload: any) => {
  return (await api.get('/solution/company', { params: { companyId: payload.companyId } })).data;
});

const companySlice = createSlice({
  name: 'company',
  initialState: {
    current: null as any | null,
    list: [] as any[],
    solutions: [] as any[],
    solutionIds: [] as number[],
  },
  reducers: {
    setCompany: (state, { payload }: PayloadAction<any>) => {
      state.current = payload;
    },
  },
  extraReducers: {
    [fetchCompanyList.fulfilled.type]: (state, { payload }: PayloadAction<any>) => {
      state.list = payload.company.map((pbCompany: any) => pbCompany.toJSON());

      const approvedCompanyList = payload.company.filter((item: any) => item.statusCode === 200);

      state.current = approvedCompanyList.length > 0 ? approvedCompanyList[0].toJSON() : null;
    },
    [fetchCompanyList.rejected.type]: (state) => {
      state.list = [];
    },
    [fetchCompanySolutionList.fulfilled.type]: (state, { payload }: PayloadAction<any>) => {
      state.solutionIds = payload.solution.map((pbSolution: any) => pbSolution.solutionId);
    },
    [fetchCompanySolutionList.rejected.type]: (state) => {
      state.solutions = [];
    },
  },
});

export const { setCompany } = companySlice.actions;
export default companySlice.reducer;
